import { FlexProps } from "antd";

import { StyledContainer, Mask, ContentWrapper } from "./styles";
import { useClientSettings } from "@hooks/useClientSettings";

type ContainerWithImageBgProps = FlexProps & {
  hideImage?: boolean;
};

export const ContainerWithImageBg = ({
  children,
  hideImage,
  ...props
}: ContainerWithImageBgProps) => {
  const client = useClientSettings();
  return (
    <StyledContainer>
      <Mask $hideImage={hideImage || !client.assets.background} />

      <ContentWrapper vertical {...props}>
        {children}
      </ContentWrapper>
    </StyledContainer>
  );
};

export default ContainerWithImageBg;
